import React from 'react';
import { Subscription } from './types';
import './EditSubscriptionModal.css';

interface EditSubscriptionModalProps {
    subscription: Subscription | null;
    onSave: (subscription: Subscription) => void;
    onClose: () => void;
}

const EditSubscriptionModal: React.FC<EditSubscriptionModalProps> = ({
    subscription,
    onSave,
    onClose
}) => {
    const [editingData, setEditingData] = React.useState<Subscription | null>(null);

    React.useEffect(() => {
        setEditingData(subscription);
    }, [subscription]);

    if (!subscription || !editingData) return null;

    const handleChange = (field: keyof Subscription, value: string) => {
        setEditingData(prev => ({
            ...prev!,
            [field]: value
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSave(editingData);
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Subscription {subscription._id} edit</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Current Credits:</label>
                        <input
                            type="number"
                            value={editingData.currentCredits}
                            min={0}
                            max={10000}
                            onChange={(e) => handleChange('currentCredits', e.target.value)}
                        />
                    </div>

                    <div className="modal-buttons">
                        <button type="button" onClick={onClose} className="cancel-button">Cancel</button>
                        <button type="submit" className="save-button">Save</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditSubscriptionModal; 